import React from "react";
import PopupWin from "../../../../../components/PopupWin";

const DisconnectModal = ({ visible, onClose, onConfirm }) => {
  return (
    <PopupWin
      visible={visible}
      onClose={onClose}
      hideClose={false}
      popupStyle={{
        width: "427px",
        minHeight: "200px",
        padding: 0,
        background: "#ffffff",
        borderRadius: "10px",
        boxShadow: "0px 9px 25px 0px rgba(129, 155, 163, 0.27)",
      }}
      contentStyle={{
        padding: "40px 60px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
      }}
    >
      <h2 className="disconnect-modal-title">Disconnect HubSpot?</h2>
      <p className="disconnect-modal-description">
        Are you sure you want to disconnect HubSpot integration? All mapping
        configurations will be lost.
      </p>
      <div className="disconnect-modal-buttons">
        <button className="disconnect-modal-cancel" onClick={onClose}>
          Cancel
        </button>
        <button className="disconnect-modal-confirm" onClick={onConfirm}>
          Disconnect
        </button>
      </div>
    </PopupWin>
  );
};

export default DisconnectModal;
